import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faFileAudio,
} from "@fortawesome/free-solid-svg-icons";

import { POST_STATUS } from "../constants";
import { faFile } from "@fortawesome/free-regular-svg-icons";

export const getNestedError = (errors, name) => {
  if (!errors || !name) return null;
  const keys = name.split(".");
  return keys.reduce((acc, key) => (acc && acc[key] ? acc[key] : null), errors);
};

export const getStatusLabel = (status, className, refs) => {
  let statusRefs = POST_STATUS;
  if (refs) statusRefs = refs;
  switch (status) {
    case "confirmed":
      return (
        <span className={`text-info ${className}`}>{statusRefs.confirmed}</span>
      );
    case "rejected":
      return (
        <span className={`text-error ${className}`}>{statusRefs.rejected}</span>
      );
    case "done":
      return (
        <span className={`text-success ${className}`}>{statusRefs.done}</span>
      );
    case "replied":
      return (
        <span className={`text-success ${className}`}>
          {statusRefs.replied}
        </span>
      );
    case "waiting":
      return (
        <span className={`text-gray-dark ${className}`}>
          {statusRefs.waiting}
        </span>
      );
    default:
      return <span className={`${className}`}>{statusRefs[status]}</span>;
  }
};

export const getFileIcon = (fileName) => {
  const imageExtensions = [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".bmp",
    ".tiff",
    ".webp",
  ];
  const videoExtensions = [
    ".mp4",
    ".mkv",
    ".avi",
    ".mov",
    ".flv",
    ".wmv",
    ".webm",
  ];
  const audioExtensions = [".mp3", ".wav", ".ogg", ".flac", ".aac", ".m4a"];
  const wordExtensions = [".doc", ".docx"];
  const excelExtensions = [".xls", ".xlsx"];
  const powerpointExtensions = [".ppt", ".pptx"];
  const pdfExtensions = [".pdf"];

  const fileExtension = fileName
    .slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2)
    .toLowerCase();

  if (imageExtensions.includes(`.${fileExtension}`)) {
    return <FontAwesomeIcon icon={faFileImage} className="text-[#0072c6]" />;
  } else if (videoExtensions.includes(`.${fileExtension}`)) {
    return <FontAwesomeIcon icon={faFileVideo} className="text-[#80397b]" />;
  } else if (audioExtensions.includes(`.${fileExtension}`)) {
    return <FontAwesomeIcon icon={faFileAudio} className="text-[#9DD0FF]" />;
  } else if (wordExtensions.includes(`.${fileExtension}`)) {
    return <FontAwesomeIcon icon={faFileWord} className="text-[#2b579a]" />;
  } else if (excelExtensions.includes(`.${fileExtension}`)) {
    return <FontAwesomeIcon icon={faFileExcel} className="text-[#217346]" />;
  } else if (powerpointExtensions.includes(`.${fileExtension}`)) {
    return (
      <FontAwesomeIcon icon={faFilePowerpoint} className="text-[#d24726]" />
    );
  } else if (pdfExtensions.includes(`.${fileExtension}`)) {
    return <FontAwesomeIcon icon={faFilePdf} className="text-[#d24726]" />;
  } else {
    return <FontAwesomeIcon icon={faFile} />;
  }
};

export const renderBody = (htmlContent, embeddedFiles = []) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");

  const images = doc.querySelectorAll("img");
  const host = process.env.REACT_APP_BASE_URL;

  images.forEach((img) => {
    const id = img.getAttribute("id");

    if (id && (!host || !id.includes(host))) {
      const fileAccessToken = embeddedFiles.find((c) => {
        return c.fileId === id;
      })?.fileAccessToken;
      if (fileAccessToken) {
        img.setAttribute("src", `/api/file/${fileAccessToken}`);
        img.setAttribute("id", id);
      }
    }
  });

  return doc.body.innerHTML;
};
